import * as Sentry from '@sentry/browser';

const send = ({ level, capture, currentPage }, additionalData) => {
  Sentry.withScope((scope) => {
    scope.setTag('current-page', currentPage);
    scope.setLevel(level);
    Object.entries(additionalData).forEach((elem) => {
      scope.setExtra(...elem);
    });
    Sentry.captureException(capture);
  });
};

const sendInfo = ({ info, currentPage, additionalData }) => {
  send({ level: 'info', capture: info, currentPage }, additionalData);
};
const sendWarning = ({ warning, currentPage, additionalData }) => {
  send({ level: 'warning', capture: warning, currentPage }, additionalData);
};
const sendError = ({ err, currentPage, additionalData }) => {
  send({ level: 'error', capture: err, currentPage }, additionalData);
};

export {
  sendInfo,
  sendWarning,
  sendError,
};
